import { render, staticRenderFns } from "./allComment.vue?vue&type=template&id=7f75ebf3&scoped=true"
import script from "./allComment.vue?vue&type=script&lang=js"
export * from "./allComment.vue?vue&type=script&lang=js"
import style0 from "./allComment.vue?vue&type=style&index=0&id=7f75ebf3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f75ebf3",
  null
  
)

export default component.exports